import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import image from '../../assets/rent-car.jpg'
import image from "../../assets/cars-bg2jpg.jpg";
import { useDispatch, useSelector } from "react-redux";
import { cleanData, clearEditCarID } from "../../redux/Slice/formSlice";
import Swal from "sweetalert2";
const RentCar = () => {
  const loginDetail = useSelector((state) => state?.auth?.loginId);
  const dispatch = useDispatch();
  const editCarID = useSelector((state) => state?.form?.editCarID);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
    if (editCarID) {
      dispatch(cleanData());
      dispatch(clearEditCarID());
    }
  };
  const handleClick = () => {
    if (loginDetail) {
      const missingFields = [];
      if (!userDetail?.data?.image) missingFields.push("Profile photo");
      if (!userDetail?.data?.address) missingFields.push("Address");
      if (!userDetail?.data.identityFront)
        missingFields.push("Identity card front side");
      if (!userDetail?.data?.identityBack)
        missingFields.push("Identity card back side");
      if (missingFields.length > 0) {
        // Join missing fields into a message
        const missingFieldsMessage = missingFields.join(", ");

        // Show SweetAlert with a specific message for missing fields
        Swal.fire({
          title: "Please complete your profile first!",
          text: `You need to complete the following fields: ${missingFieldsMessage}`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          customClass:{
            confirmButton: 'btn img-btn',
          }
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/edit-profile");
            // Redirect the user to the profile page
            // history.push('/profile'); // or `navigate('/profile')` in React Router v6+
          } else {
            navigate("/edit-profile");
          }
        });
      } else {
        navigate("/rentyourcar");
      }
    } else {
      navigate("/login");
    }
    scrollToTop();
  };
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(#ffffff00, #000), url(${image})`,
      }}
      className="backgroundImg "
    >
      <div className="align-items-center container d-flex h-100">
        <div className="">
          {/* fs3 class removed from below line and added fs_40 */}
          <p className="primaryColor font mb-1 fs_5 ">
            Want to Rent your own car?
          </p>
          <p className="primaryColor fs14 mb-2">
            {" "}
            List Your Car Now and start earning with theRides! Join our
            community of car owners making the most of their vehicles.
          </p>
          {/* <Link
            to={loginDetail ? "/rentyourcar" : "/login"}
            onClick={scrollToTop}
          > */}
          <button
            onClick={handleClick}
            type="button"
            className="btn img-btn primaryColor rounded-0"
          >
            Rent your Car
          </button>
          {/* </Link> */}
        </div>
      </div>
    </div>
  );
};

export default RentCar;
